const hotTags = [
  '这瓜保熟吗',
  '震惊到我',
  '蹲个后续',
  '吃瓜群众集合',
  '原来如此啊',
  '我滴妈呀',
  '静静看你装',
  '乐死我了',
  '别装了好吧',
  '坐等反转',
  '好家伙',
  '前排围观',
];

export default function HotTags() {
  return (
    <section id="hot" className="bg-accent-100/50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div className="max-w-xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs text-accent-700">
              <i className="ri-fire-line" /> 今日实时热搜
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">今日吃瓜热梗</h2>
            <p className="mt-3 text-base text-foreground-700">
              围观圈最近都在用哪句梗？点开就能快速找到对应场景的表情包，聊天不冷场。
            </p>
          </div>
          <button
            onClick={() => document.getElementById('library')?.scrollIntoView({ behavior: 'smooth' })}
            className="whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm text-background-50 transition-colors hover:bg-accent-600"
          >
            去看对应表情
          </button>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {hotTags.map((tag, i) => (
            <button
              key={tag}
              onClick={() => document.getElementById('library')?.scrollIntoView({ behavior: 'smooth' })}
              className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-4 py-3 text-left transition-colors hover:border-accent-300 hover:bg-accent-50"
            >
              <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-sm font-bold text-accent-700">
                {i + 1}
              </span>
              <span className="truncate text-sm text-foreground-800 group-hover:text-accent-700">{tag}</span>
              <i className="ml-auto text-foreground-300 ri-arrow-right-line" />
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}